import { render, staticRenderFns } from "./BankAlreadyConnectedSonInvestigationModal.vue?vue&type=template&id=0e885a46&scoped=true"
import script from "./BankAlreadyConnectedSonInvestigationModal.vue?vue&type=script&lang=js"
export * from "./BankAlreadyConnectedSonInvestigationModal.vue?vue&type=script&lang=js"
import style0 from "./BankAlreadyConnectedSonInvestigationModal.vue?vue&type=style&index=0&id=0e885a46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e885a46",
  null
  
)

export default component.exports